export const NAME_SPACE = 'fe-popups'
